// @unocss-include
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { getDeferredPrompt, installState, triggerInstall } from '../install.js';
import { useAppInfo, useMaybeAppId } from '../react.js';
let singleton;
export function PwaInstaller() {
    const maybeApp = useMaybeAppId();
    if (!maybeApp)
        return null;
    return _jsx(PwaInstallerInner, {});
}
function PwaInstallerInner() {
    const app = useAppInfo();
    const ref = useRef(null);
    useEffect(() => {
        const pwaInstall = ref.current;
        if (!pwaInstall)
            return;
        singleton = pwaInstall;
        pwaInstall.manifestUrl = '/manifest.webmanifest';
        pwaInstall.icon = app.iconPath;
        pwaInstall.name = app.name;
        pwaInstall.description = app.description;
        pwaInstall.installDescription = 'Install this app on your device';
        pwaInstall.externalPromptEvent = getDeferredPrompt();
        pwaInstall.manualChrome = true;
        pwaInstall.manualApple = true;
        pwaInstall.disableChrome = true;
    }, [app]);
    return _jsx("pwa-install", { ref: ref });
}
PwaInstaller.show = () => {
    if (singleton)
        singleton.showDialog();
    else if (installState.installReady)
        triggerInstall();
};
//# sourceMappingURL=PwaInstaller.js.map